import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import twitterFill from '@iconify/icons-eva/twitter-fill'
import linkedinFill from '@iconify/icons-eva/linkedin-fill'
import facebookFill from '@iconify/icons-eva/facebook-fill'
import instagramFilled from '@iconify/icons-ant-design/instagram-filled'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import { sentenceCase } from 'change-case'
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'

import {
  Box,
  Card,
  Grid,
  Avatar,
  Tooltip,
  Divider,
  Stack,
  Typography,
  IconButton,
  AvatarGroup,
  Button,
  Paper,
  Chip,
} from '@material-ui/core'
// utils
import { fShortenNumber } from 'src/utils/formatNumber'
//
import SvgIconStyle from 'src/components/SvgIconStyle'
import Label from 'src/components/Label'
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { buildCommunityNavigateState } from 'src/helpers/communityPageNavigation'
import { Folder, Message, MessageSharp, RequestQuote } from '@material-ui/icons'
import moment from 'moment'
import { getAgoString } from 'src/common/Helper'
import { UserMoreMenu } from 'src/components/_dashboard/user/list'
import axios from 'axios'
import { REST_API, REST_API_END_POINT, COMPANY_LOGO } from 'src/constants/Defaultvalues'
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup'
import { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack'
import Modal from 'src/components/_dashboard/blog/ProjectModel'
import UserOptionsMore from 'src/components/_dashboard/user/list/UserOptionsMore'
// ----------------------------------------------------------------------

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  paddingTop: 'calc(100% * 2 / 5)',
  height: '90px',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    WebkitBackdropFilter: 'blur(3px)',
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,
  },
}))

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  //    background: `url(${src}) center/cover no-repeat`
})

// ----------------------------------------------------------------------

function InfoItem(number) {
  return (
    <Grid item xs={4}>
      <Typography
        variant="caption"
        sx={{ mb: 0.5, color: 'text.secondary', display: 'block' }}
      >
        Follower
      </Typography>
      <Typography variant="subtitle1">{fShortenNumber(number)}</Typography>
    </Grid>
  )
}

communityCard.propTypes = {
  card: PropTypes.object.isRequired,
}

export default function communityCard({ card, clientProject, isVendor, fromClient, salesRepData, clientData, onRefresh }) {
  const theme = useTheme()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar();
  const [openDeletePop, setOpenDeletePop] = useState(false);
  const [deletingId, setDeletingId] = useState();
  const [deletingName, setDeletingName] = useState('');
  // const [requestCount,setRequestCount] = useState();
  // const [projectCount,setProjectCount] = useState();
  const [viewData, setViewData] = useState(null);
  console.log("viewDataviewDataviewData", viewData)
  const [taxCategories, setTaxCategories] = useState(null);


  useEffect(() => {
    if (viewData) {

      fetchTaxCategory()
    }
  }, [viewData])

  const fetchTaxCategory = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
      if (response.data.status === 1) {
        let result = response.data.taxResult.filter((data) => viewData.tax_category === data.id)
        console.log("resultresultresult", result)
        setTaxCategories(result[0]);
      } else {
        setTaxCategories(null)
      }
    } catch (error) {
      console.log("Error - ", error);
      setTaxCategories(null)
    }
  }

  let user = JSON.parse(localStorage.getItem('user'))
  const userType = user.user_type
  const explodedPermissions = user?.exploded_permissions;
  const userId = user.user_id

  const salesOrderPermission = explodedPermissions?.some((permission) =>
    ['View request', 'Delete request', 'Edit Request'].includes(permission)) ? true : false

  const designOrderPermission = explodedPermissions?.some((permission) =>
    ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)) ? true : false

  const installPermission = explodedPermissions?.some((permission) =>
    ['View All Installations'].includes(permission)) ? true : false

  const jobPermission = explodedPermissions?.some((permission) =>
    ['View Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)) ? true : false
  const estimatePermission = explodedPermissions?.some((permission) =>
    ['Create Estimate', 'Edit Estimate', 'View Estimate', 'Delete Estimate'].includes(permission)) ? true : false
  console.log("estimatePermissionestimatePermissionestimatePermission", estimatePermission);

  const {
    image,
    message,
    timestamp,
    id,
    name,
    status,
    request,
    authorized_by,
    people,
    description,
    subject,
    submission_deadline,
    msg_count,
    proposal_count,
    participation_ends,
    services,
    accept_status,
    thumbnail,
    client_profile_pic,
    type,
    clientName,
    email,
    phone,
    requestCount,
    projectCount,
    installsCount,
    designsCount,
    no_of_requests,
    no_of_projects,
    no_of_installs,
    no_of_designs,
    no_of_estimates = 0,
    clients
  } = card
  // const fetchData = async () => {
  //   try{
  //     const requestResponse = await axios.post(`${REST_API}webservice/rfq/get-request-by-community`,{communityId:id, userId, userType})
  //     const projectResponse = await axios.post(`${REST_API}webservice/rfq/get-project-by-community`,{communityId:id, userId, userType})
  //     if(requestResponse.data){
  //       const request = requestResponse.data.data
  //       setRequestCount(request?.length)
  //     }
  //     if(projectResponse.data){
  //       const project = projectResponse.data.data
  //       setProjectCount(project?.length)
  //     }
  //   }
  //   catch(error){
  //     console.log("fetchData Error : ",error);
  //   }
  // }

  // useEffect(()=>{
  //   fetchData();
  // },[])

  const updatedAt = moment.unix(timestamp).format('YYYY-MM-DD')
  //status color
  const getStatusColorAndLabel = (status) => {
    switch (status) {
      case 1:
        return { color: 'success', label: 'Status: Active' }
      case 0:
        return { color: 'warning', label: 'Status: Inactive' }
      case 2:
        return { color: 'error', label: 'Status: Deleted' }
      default:
        return { color: 'default', label: 'Status: Open' }
    }
  }

  const changeStatus = async (comId, comStatus) => {
    try {
      let deleteId = comId;
      let status = comStatus;
      let response = await axios.post(`${REST_API_END_POINT}community/delete-community`, { deleteId, status, userId });
      //   console.log("response-----------------", response.data);
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        if (clientProject && onRefresh) {
          onRefresh();
        } else {
          navigate(PATH_DASHBOARD.community.root, { state: { data: `${response.data.message}+${deleteId}` } });
        }
      }
      else if (response.data.status === 0) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
        if (clientProject && onRefresh) {
          onRefresh();
        } else {
          navigate(PATH_DASHBOARD.community.root, { state: { data: `${response.data.message}+${deleteId}` } });
        }
      }
      else {
        console.log("Error.........!");
        enqueueSnackbar("Server Error...!", { variant: 'error' });
        if (clientProject && onRefresh) {
          onRefresh();
        } else {
          navigate(PATH_DASHBOARD.community.root, { state: { data: `${response.data.message}+${deleteId}` } });
        }
      }
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }

  const handleMenuClick = async (id, status) => {
    let newStatus;
    (status === 1) ? newStatus = 0 : newStatus = 1
    // console.log("id, newStatus",id, newStatus);
    await changeStatus(id, newStatus);
  }

  const handleDeleteClick = async (id, newStatus) => {
    // console.log("id, newStatus",id, newStatus);
    setDeletingName('');
    setDeletingId();
    setOpenDeletePop(false);
    await changeStatus(id, newStatus);
  }

  return (
    <Card
      id={id}
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        height: 'fit-content',
        overflow: 'hidden',
        cursor: 'pointer',
        border: theme.palette.mode === 'light' ? `1px solid ${theme.palette.divider}` : `1px solid ${theme.palette.divider}`,
      }}
      onClick={() => {
        if (explodedPermissions?.some(permission => ['Edit Projects'].includes(permission)) || userType === 3) {
          if (clientProject && clientData) {
            navigate(PATH_DASHBOARD.community.create, { state: { data: id, fromClientProject: true, clientData: clientData } })
          } else {
            navigate(PATH_DASHBOARD.community.create, { state: { data: id } })
          }
        }
      }}
    >
      <CardMediaStyle>
        <AvatarGroup
          max={7}
          sx={{ '& .MuiAvatar-root': { width: 62, height: 62, zIndex: 10 } }}
        >
        </AvatarGroup>
        <CoverImgStyle
          alt="cover"
          src={thumbnail ? thumbnail :
            ((client_profile_pic && client_profile_pic !== 'avatar.jpg' && client_profile_pic !== '')
              ? client_profile_pic : COMPANY_LOGO)}
        />
        <Typography sx={{ position: 'absolute', top: 4, left: 6, zIndex: 10 }}>
          <Label
            variant="filled"
            color={getStatusColorAndLabel(status).color}
            sx={{ fontSize: '12px', px: 0.5, py: 0.15 }}
          >
            {getStatusColorAndLabel(status).label}
          </Label>
        </Typography>
        {clientProject ? '' : <Tooltip title={clientName}>
          <Typography sx={{ position: 'absolute', maxWidth: 150, bottom: 4, left: 6, zIndex: 10 }}>
            <Label
              variant="filled"
              color={'warning'}
              sx={{
                fontSize: '12px',
                px: 0.5,
                py: 0.15,
                justifyContent: 'flex-start',
                whiteSpace: 'nowrap', // Prevent line break
                overflow: 'hidden',   // Hide text overflow
                textOverflow: 'ellipsis', // Add ellipsis for long text
                maxWidth: '100%', // Ensure it doesn't overflow beyond available width
              }}
            >
              {clientName}
            </Label>
          </Typography>
        </Tooltip>}
        <Box
          // sx={{ position: 'absolute', top: 8, right: 10, zIndex: 10, borderRadius:50 }}
          sx={{
            position: 'absolute',
            top: 6,
            right: 8,
            zIndex: 10,
            borderRadius: '50%',
            backdropFilter: 'blur(6px)',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
            padding: '2px',
            width: '32px',
            height: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <UserOptionsMore
            stopPropagation={true}
            onDelete={() => {
              if (explodedPermissions?.some(permission => ['Delete Projects'].includes(permission))) {
                setOpenDeletePop(true);
                setDeletingId(id);
                setDeletingName(name);
              } else {
                enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
              }
            }}
            onEdit={() => {
              if (explodedPermissions?.some(permission => ['Edit Projects'].includes(permission)) || userType === 3) {
                if (clientProject && clientData) {
                  navigate(PATH_DASHBOARD.community.create, { state: { data: id, fromClientProject: true, clientData: clientData } })
                } else {
                  navigate(PATH_DASHBOARD.community.create, { state: { data: id } })
                }
              } else {
                enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
              }
            }}
            onStatusChange={() => {
              if (explodedPermissions?.some(permission => ['Activate/Deactivate Projects'].includes(permission))) {
                handleMenuClick(id, status)
              } else {
                enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
              }
            }}
            status={status}
            oppName={name}
            oppId={id}
            project={true}
            userType={userType}
          />
        </Box>
      </CardMediaStyle>
      {userType == 3 && accept_status == 2 && status !== 6 && (
        <Typography
          color={theme.palette.error.light}
          variant="body2"
          align="center"
        // sx={{ color: 'text.secondary' }}
        >
          Sorry, You are not eligible to view the request
          because you have not accepted the request
          on or before the Evaluation Stage
        </Typography>

      )}
      <Typography
        variant="subtitle2"
        align="center"
        sx={{
          mt: 0.5,
          mb: 0.25,
          fontSize: '13px',
          fontWeight: 500,
          color: theme.palette.mode === 'light' ? '#00a1d2' : theme.palette.primary.main,
          cursor: 'pointer',
          px: 0.75,
        }}
        onClick={(e) => { e.stopPropagation(); setViewData(card) }}
      >
        {name}
      </Typography>
      <Tooltip title={description}>
        <Box sx={{ display: 'flex', justifyContent: 'center', px: 0.75 }}>
          <Typography
            variant="caption"
            sx={{
              fontSize: '11px',
              cursor: 'pointer',
              display: 'inline-block',
              minHeight: 18,
              maxWidth: '95%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'center',
              whiteSpace: 'nowrap',
              color: 'text.secondary',
              mb: 0.5
            }}
          >
            {description}
          </Typography>
        </Box>
      </Tooltip>
      {/* <Tooltip title={clientName}>
        <Box sx={{ display: 'flex', justifyContent: 'center', px: 0.75 }}>
        <Typography
          variant="caption"
          sx={{
            fontSize: '11px',
            cursor: 'pointer',
            display: 'inline-block',
            minHeight: 18,
            maxWidth: '95%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            color: 'text.secondary',
            mb: 0.5
          }}
        >
          {clientName}
        </Typography>
        </Box>
      </Tooltip> */}
      <Typography
        variant="overline"
        align="center"
        sx={{ color: 'text.secondary' }}
      ></Typography>

      <Grid
        container
        spacing={0.5}
        sx={{ my: 0.5, px: 0.5, display: 'flex', justifyContent: 'space-between', flexWrap: 'nowrap' }}
      >
        {/* Sales Orders */}
        <Grid item xs={userType == 3 ? 4 : 3} sx={{ textAlign: 'center', px: 0.25 }}>
          <Stack
            sx={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer', gap: 0.1 }}
            onClick={(e) => {
              e.stopPropagation(); salesOrderPermission ?
                navigate(PATH_DASHBOARD.community.rfqCommunity, {
                  state: buildCommunityNavigateState(id, name, clients, clientProject && clientData ? clientData : null),
                })
                : enqueueSnackbar("Access Denied: You do not have permission to view sales orders", { variant: 'error' })
            }}
          >
            <Folder sx={{ fontSize: '14px', color: salesOrderPermission ? theme.palette.warning.main : theme.palette.divider }} />
            <Typography variant="caption" sx={{ fontSize: '12px', lineHeight: 1.1 }}>Sales Orders</Typography>
            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: salesOrderPermission ? theme.palette.mode === 'light' ? '#00a1d2' : theme.palette.primary.main : theme.palette.divider }}>
              {salesOrderPermission ? no_of_requests : 'N/A'}
            </Typography>
          </Stack>
        </Grid>

        {/* Jobs (Visible only if userType !== 3) */}
        {userType == 3 ? '' : (
          <Grid item xs={3} sx={{ textAlign: 'center', px: 0.25 }}>
            <Stack
              sx={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer', gap: 0.1 }}
              onClick={(e) => {
                e.stopPropagation(); jobPermission ?
                  navigate(PATH_DASHBOARD.community.rfqProjects, {
                    state: buildCommunityNavigateState(id, name, clients, clientProject && clientData ? clientData : null),
                  })
                  : enqueueSnackbar("Access Denied: You do not have permission to view jobs", { variant: 'error' })
              }}
            >
              <Folder sx={{ fontSize: '14px', color: jobPermission ? theme.palette.warning.main : theme.palette.divider }} />
              <Typography variant="caption" sx={{ fontSize: '12px', lineHeight: 1.1 }}>Jobs</Typography>
              <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: jobPermission ? theme.palette.mode === 'light' ? '#00a1d2' : theme.palette.primary.main : theme.palette.divider }}>
                {jobPermission ? no_of_projects : 'N/A'}
              </Typography>
            </Stack>
          </Grid>
        )}

        {/* Installs */}
        <Grid item xs={userType == 3 ? 4 : 3} sx={{ textAlign: 'center', px: 0.25 }}>
          <Stack
            sx={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer', gap: 0.1 }}
            onClick={(e) => {
              e.stopPropagation(); installPermission ? navigate(PATH_DASHBOARD.community.rfqInstalls, {
                state: buildCommunityNavigateState(id, name, clients, clientProject && clientData ? clientData : null),
              })
                : enqueueSnackbar("Access Denied: You do not have permission to view installations", { variant: 'error' })
            }}
          >
            <Folder sx={{ fontSize: '14px', color: installPermission ? theme.palette.warning.main : theme.palette.divider }} />
            <Typography variant="caption" sx={{ fontSize: '12px', lineHeight: 1.1 }}>Installs</Typography>
            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: installPermission ? theme.palette.mode === 'light' ? '#00a1d2' : theme.palette.primary.main : theme.palette.divider }}>
              {installPermission ? no_of_installs : 'N/A'}
            </Typography>
          </Stack>
        </Grid>

        {/* Designs */}
        <Grid item xs={userType == 3 ? 4 : 3} sx={{ textAlign: 'center', px: 0.25 }}>
          <Stack
            sx={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer', gap: 0.1 }}
            onClick={(e) => {
              e.stopPropagation(); designOrderPermission ?
                navigate(PATH_DASHBOARD.community.rfqDesigns, {
                  state: buildCommunityNavigateState(id, name, clients, clientProject && clientData ? clientData : null),
                })
                : enqueueSnackbar("Access Denied: You do not have permission to view designs", { variant: 'error' })
            }}
          >
            <Folder sx={{ fontSize: '14px', color: designOrderPermission ? theme.palette.warning.main : theme.palette.divider }} />
            <Typography variant="caption" sx={{ fontSize: '12px', lineHeight: 1.1 }}>Designs</Typography>
            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: designOrderPermission ? theme.palette.mode === 'light' ? '#00a1d2' : theme.palette.primary.main : theme.palette.divider }}>
              {designOrderPermission ? no_of_designs : 'N/A'}
            </Typography>
          </Stack>
        </Grid>
        {/* Estimates */}
        <Grid item xs={userType == 3 ? 4 : 3} sx={{ textAlign: 'center', px: 0.25 }}>
          <Stack
            sx={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer', gap: 0.1 }}
            onClick={(e) => {
              e.stopPropagation(); estimatePermission ?
                navigate(PATH_DASHBOARD.community.rfqEstimates, {
                  state: buildCommunityNavigateState(id, name, clients, clientProject && clientData ? clientData : null),
                })
                : enqueueSnackbar("Access Denied: You do not have permission to view estimates", { variant: 'error' })
            }}
          >
            <Folder sx={{ fontSize: '14px', color: estimatePermission ? theme.palette.warning.main : theme.palette.divider }} />
            <Typography variant="caption" sx={{ fontSize: '12px', lineHeight: 1.1 }}>Estimates</Typography>
            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: designOrderPermission ? theme.palette.mode === 'light' ? '#00a1d2' : theme.palette.primary.main : theme.palette.divider }}>
              {estimatePermission ? no_of_estimates : 'N/A'}
            </Typography>
          </Stack>
        </Grid>
      </Grid>


      <Divider sx={{ my: 0.25 }} />
      <Tooltip title={type}>
        <Typography
          variant="caption"
          align="center"
          sx={{ mt: 0.25, mb: 0.25, fontSize: '12px', color: 'text.secondary', px: 0.5 }}
        >
          {type}
        </Typography>
      </Tooltip>
      <Grid
        container
        sx={{
          textAlign: 'center',
          justifyContent: 'flex-end',
          display: 'flex',
          flexDirection: 'row',
          gap: 0.5,
          pb: 0.5,
          pr: 0.75,
        }}
      >
        {msg_count && <Typography
          variant="caption"
          align="center"
          sx={{ fontSize: '12px', color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 0.25 }}
        >
          <MessageSharp sx={{ width: 12, height: 12 }} />
          {msg_count}
        </Typography>}
        {proposal_count && <Typography
          variant="caption"
          align="center"
          sx={{ fontSize: '12px', color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 0.25 }}
        >
          <RequestQuote sx={{ width: 12, height: 12 }} />
          {proposal_count}
        </Typography>}
      </Grid>
      <ConfirmationPopup
        open={openDeletePop}
        handleClose={() => { setOpenDeletePop(false) }}
        message={`You want to delete ${deletingName} ! `}
        handleClick={() => { handleDeleteClick(deletingId, 2) }}
      />
      <Modal
        modalTitle={'View Project'}
        open={viewData ? true : false}
        handleClose={(e) => {
          e.stopPropagation()
          setViewData(null)
        }}
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <Grid container sx={{ justifyContent: 'center', }} spacing={3} onClick={(e) => { e.stopPropagation() }}>
          <Grid item xs={12} md={12}>
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              spacing={3}
              onClick={(e) => { e.stopPropagation() }}
            >
              <Paper
                key={'ddf'}
                sx={{
                  p: 3,
                  width: 1,
                  bgcolor: 'background.neutral'
                }}
                onClick={(e) => { e.stopPropagation() }}
              >
                <Typography variant="subtitle1" gutterBottom>
                  <span style={{ color: viewData?.name ? 'inherit' : 'inherit' }}>
                    Name : {viewData?.name}
                  </span>
                </Typography>
                {/* <Typography variant="subtitle1" gutterBottom>
                <span style={{ color: viewData?.poNumber ? 'inherit' : 'inherit' }}>
                  PO# : {viewData?.poNumber} 
                </span>
              </Typography> */}
                <Box display="flex" flexDirection="row" alignItems="flex-start" sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" style={{ color: viewData?.description ? 'inherit' : 'inherit', marginRight: '8px', flexShrink: 0 }}>
                    Description :
                  </Typography>
                  <Typography variant="subtitle1" style={{ whiteSpace: 'pre-line', color: viewData?.description ? 'inherit' : 'inherit' }}>
                    {viewData?.description}
                  </Typography>
                </Box>
                {/* <Typography variant="subtitle1" gutterBottom>
                <span style={{ color: viewData?.type ? 'inherit' : 'inherit' }}>
                Project Type : {viewData?.type} 
                </span>
              </Typography> */}
                <Typography variant="subtitle1" gutterBottom>
                  <span style={{ color: viewData?.type ? 'inherit' : 'inherit' }}>
                    Clients : {viewData?.clientName}
                  </span>
                </Typography>
                {viewData?.po_details && viewData.po_details.length > 0 && (
                  <>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                      <Typography variant="subtitle1" gutterBottom>PO#:</Typography>
                      {viewData.po_details.map((po, index) => (
                        <Tooltip title={`PO Number: ${po.po_number}`} key={index}>
                          <Chip
                            key={index}
                            label={po.po_name || `PO ${index + 1}`}
                            size="small"
                            variant="outlined"
                            color="primary"
                          />
                        </Tooltip>
                      ))}
                    </Box>
                  </>)}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ mr: 1 }}>
                    Sales Reps :
                  </Typography>
                  {viewData?.sales_rep_ids && salesRepData && salesRepData.length > 0 ? (
                    <AvatarGroup max={4}>
                      {viewData.sales_rep_ids.split(',').map(id => {
                        const rep = salesRepData.find(r => r.id === Number(id.trim()));
                        return rep ? (
                          <Tooltip key={rep.id} title={rep.userName}>
                            <Avatar
                              alt={rep.userName}
                              src={rep.profile_pic}
                              sx={{ width: 40, height: 40 }}
                            />
                          </Tooltip>
                        ) : null;
                      }).filter(Boolean)}
                    </AvatarGroup>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      N/A
                    </Typography>
                  )}
                </Box>

                <Typography variant="subtitle1" gutterBottom>
                  <span style={{ color: viewData?.email ? 'inherit' : 'inherit' }}>
                    Email : {viewData?.email}
                  </span>
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <span style={{ color: viewData?.phone ? 'inherit' : 'inherit' }}>
                    Contact No : {viewData?.phone ? `+${viewData?.phone_country_code || '1'}${viewData?.phone}` : ''}
                  </span>
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <span style={{ color: viewData?.phone_extension ? 'inherit' : 'inherit' }}>
                    Phone Extension : {viewData?.phone_extension || '-'}
                  </span>
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <span style={{ color: viewData?.address ? 'inherit' : 'inherit' }}>
                    Address : {viewData?.address}
                  </span>
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <span style={{ color: viewData?.authorized_by ? 'inherit' : 'inherit' }}>
                    Created By : {viewData?.authorized_by}
                  </span>
                </Typography>

                {/* <Typography variant="subtitle1" gutterBottom>
                <span style={{ color: viewData?.tax_category ? 'inherit' : 'inherit' }}>
                Tax Category: {taxCategories? taxCategories?.name : 'Nill'} 
                </span>
              </Typography>
              <Typography variant="subtitle1" gutterBottom>
                <span style={{ color: viewData?.tax_category ? 'inherit' : 'inherit' }}>
                Tax Value: {taxCategories ?`${taxCategories?.value} ${taxCategories?.type==1? '%' : '$'}` : 'Nill'} 
                </span>
              </Typography> */}
                <Typography variant="body2" gutterBottom>
                  Status {' '}
                  <Label
                    variant="filled"
                    color={(viewData?.status === 1 && 'success') || 'error'}
                  >
                    {(viewData?.status === 1) ? " Active" : " Inactive"}
                  </Label>
                </Typography>
              </Paper>
              <Box
                sx={{
                  mt: 3,
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 1,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={(e) => {
                    e.stopPropagation()
                    setViewData(null)
                  }}
                  onMouseDown={(e) => { e.stopPropagation() }}
                >
                  Close
                </Button>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Modal>
    </Card>
  )
}
